import { APIMethod, fetchData } from "@client";
import { mapKeysToSnakeCase } from "@client/api/utils/fetchApiUtils";

export async function updateRateCardCategoryQuery(categoryId, data) {
  return await fetchData(
    `/company/rate-card/categories/${categoryId}`,
    APIMethod.PATCH,
    {
      isJSONData: true,
      data: mapKeysToSnakeCase(data)
    }
  );
}
